import axios from "axios";
import React, { useEffect, useState } from "react";

const Facility = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [facilities, setFacilities] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_FACILITY;
        const cacheKey = "facilityData";
        const cacheTimeKey = "facilityDataTimestamp";
        const cacheExpiry = 30 * 60 * 1000; // 30 minutes

        const cachedData = localStorage.getItem(cacheKey);
        const cacheTimestamp = localStorage.getItem(cacheTimeKey);

        if (cachedData && cacheTimestamp && (Date.now() - parseInt(cacheTimestamp, 10)) < cacheExpiry) {
            setFacilities(JSON.parse(cachedData));
        } else {
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setFacilities(response.data);
                    localStorage.setItem(cacheKey, JSON.stringify(response.data));
                    localStorage.setItem(cacheTimeKey, Date.now().toString());
                })
                .catch(error => console.error("Error fetching API", error));
        }
    }, []);

    return (
        <div className="feature-area feature-negative" style={{ marginTop: '120px' }}>
            <div className="container">
                <div className="feature-wrapper">
                    <h2 className="text-center fw-bold" style={{ paddingBottom: '50px' }}>
                        আমরা কেন সেরা ? আমাদের সুযোগ সুবিধা সমূহ
                    </h2>
                    <div className="row g-4">
                        {facilities.map((facility, index) => (
                            <div className="col-md-6 col-lg-6 col-xl-3" key={index}>
                                <div className="card feature-item">
                                    <div className="card-header d-grid justify-content-center">
                                        <div className="feature-icon">
                                            <img src={`${backendBaseUrl}${facility?.icon}`} alt="" />
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="feature-content">
                                            <h6 className="text-center fw-bold">{facility?.title}</h6>
                                            <p align="justify"><small>{facility?.details}</small></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Facility;
